import { bankArray, nameBankArray } from '@/services/modules/Bank.services.js'

export const BankMixins = {
  filters: {
    //Format bank account
    formatAccNo: function(accNo) {
      let result = '',
        index = 0,
        count = 0
      if (accNo != undefined && accNo != null) {
        for (let i = 0; i < accNo.length; i++) {
          result += accNo.charAt(i)
          index++
          if (index == 3 && i + 1 != accNo.length && count == 0) {
            result += '-'
            index = 0
            count++
          }
          if (index == 1 && i + 1 != accNo.length && count == 1) {
            result += '-'
            index = 0
            count++
          }
          if (index == 5 && i + 1 != accNo.length && count == 2) {
            result += '-'
            index = 0
            count++
          }
        }
      }
      return result
    },
  },
  methods: {
    getBankImgwithCode: function(Id) {
      var images = require.context('@/assets/img/bank_logo/', false, /\.svg$/)
      // if(Loading...)
      if (!bankArray[Id]) return ''
      return images('./' + bankArray[Id]['code'] + '.svg')
    },
    getBankColorwithCode: function(Id) {
      if (!bankArray[Id]) return false
      return bankArray[Id]['color']
    },
    getBankCode: function(Id) {
      if (!bankArray[Id]) return Id
      return bankArray[Id]['code']
    },
    getBankName(bankCode) {
      return nameBankArray[bankCode]
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/BankService.js